import script from "./System_platformEN.vue?vue&type=script&setup=true&name=System_platformEN&lang=js"
export * from "./System_platformEN.vue?vue&type=script&setup=true&name=System_platformEN&lang=js"

import "./System_platformEN.vue?vue&type=style&index=0&id=6976c970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6976c970"]])

export default __exports__